<template>
  <div class="zuiminlb">
    <div class="bt">{{cat_name}} <span>共收录{{total}}个罪名</span></div>
    <chargeslist :intlist="zmlist" class="contlist"></chargeslist>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        :current-page="currentPage"
        :pager-count="5"
        @current-change="turnpage"
        @prev-click="turnpage(--currentPage)"
        @next-click="turnpage(++currentPage)"
      >
      </el-pagination>
      <div class="textnum">[共{{ pageCount }}页]</div>
    </div>
  </div>
</template>

<script>
import chargeslist from "views/zuiming/components/chargeslist";
export default {
  props:['colId'],
  components: {
    chargeslist,
  },
  data: () => ({
    zmlist:[],
    cat_name:'危害国家安全罪',
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
  }),
  beforeMount() {
    this.getzuimin()
  },
  methods: {
    
    getzuimin(key){
      let data = {
        page:this.currentPage,
        cat_id: this.colId,
        limit: 8,
        order: 'new',
      }
      this.$http.jpcol.getzuiminlist(data)
        .then(res => {
          console.log(res.data.data);
          this.cat_name = res.data.cat_name
          this.pageCount = res.data.last_page
          this.total = res.data.total;
          this['zmlist'] = res.data.data
        })
    },
    turnpage(e) {
      this.currentPage = e
      this.getzuimin();
    },
  },
};
</script>

<style lang="scss" scoped>
.zuiminlb {
  padding: 23px 30px;
  .bt {
    font-size: 24px;
    color: #333333;
    span {
      margin-left: 20px;
      font-size: 16px;
      color: #999999;
    }
  }
  .contlist {
    margin-top: 20px;
  }
  .pagination {
    text-align: center;

    .textnum {
      color: #333;
      margin-top: 15px;
    }
  }
}
</style>